import Layout from "@/view/layout/index";
import router from '@/router'
import store from '@/store';

const routerUtil = {
    /**
     * 根据菜单加载路由信息
     * @param menus
     */
    loadRouterByMenus() {
        /** 此处可修改为调用RESTFul接口 **/
        let menus = require("@/assets/data/menus.json");
        if (!menus || menus.length < 1) {
            return;
        }

        let routers = [];
        menus.forEach((menu) => {
            let routerObj = buildRouter(menu);
            routers.push(routerObj);
        });

        if (routers.length > 0) {
            router.addRoutes(routers);
            store.dispatch("setRouterToStore",routers);
        }
        console.log("动态加载的路由数据：",routers);
    },

    /**
     * 跳转到菜单的第一个页面
     */
    showMenuFirstView() {
        let routes = store.getters.routers;
        let firstViewRouteName = routes[0].children[0].name;
        router.push({name: firstViewRouteName});
    }
}

/**
 * 路径转换成vue组件
 * @param file
 * @returns {function()}
 * @private
 */
function _import(file) {
    return () => import('@/view/' + file + '.vue')
}

/**
 * 创建路由
 * @param {*} menu
 */
function buildRouter(menu) {
    let routerChildren = [];
    let routerObj = {
        name: menu.routerName,
        path: menu.menuPath,
        hidden: !menu.isVisible,
        component: Layout,
        meta: {
            title: menu.menuName,
            icon: menu.menuIcon
        },
        children: routerChildren
    };

    menu.menus.forEach((menuChild) => {
        if (!!menuChild) {
            let routerChild = buildRouterChild(menu, menuChild);
            routerChildren.push(routerChild);
        }
    });
    return routerObj;
}

/**
 * 创建子路由
 * @param {*} menu
 * @param {*} menuChild
 */
function buildRouterChild(menu, menuChild) {
    let path = menuChild.menuPath;
    let componentPath = menuChild.menuPath;

    if (menu.menus.length === 1) {
        /** 单个子菜单修改path为模块+index: app/index**/
        path = 'index'
    } else {
        /** 父级+子级的path,从app/app/version/index修改为: app/version/index **/
        path = path.substring(path.indexOf('/') + 1)
    }

    let childRouter = {
        name: menuChild.routerName,
        path: path,
        hidden: !menuChild.isVisible,
        component: _import(componentPath),
        meta: {
            title: menuChild.menuName,
            icon: menuChild.menuIcon
        }
    };

    return childRouter;
}

export default routerUtil;



// WEBPACK FOOTER //
// ./src/utils/routerUtil.js